import DataTable from "../dataTable/DataTable";
import { edit as selected } from '../../slices/advertisementsSelectedSlice';
import { edit } from '../../slices/advertisementsFilterSlice';
import { appUrl } from "../../utils/fetch";
import AdvertisementsFilter from "./AdvertisementsFilter";
import Advertisement from "./Advertisement";
import { DesktopMacOutlined, SmartphoneOutlined } from "@mui/icons-material";



function AdvertisementsList() {
    return (
        <div>
            <AdvertisementsFilter />
            <DataTable 
                title="Ads"
                dataUrl={`${appUrl}/api/ads`}
                deleteUrl={`${appUrl}/api/ad-delete`}
                editUrl={`/ad`}
                filterStateName="advertisementsFilter"
                filterDispatchFunc={edit}
                filterUrl={`${appUrl}/api/ads`}
                url={"/advertisement/list"}
                selectedStateName="advertisementsSelected"
                dispatchFunc={selected}
                editComponent={(id, closeFunc) => {
                    return (
                        <div style={{width: "calc(1200px)"}}>
                            <Advertisement id={id} closeFunc={closeFunc}/>
                        </div>
                    )
                }}
                header={{
                    type: {
                        label: "Type",
                        field: "selectImage",
                        alt: "name",
                        data: {
                            1: {
                                name: "Video Overlay Banner 300x250( left )",
                                src: "ad1.png"
                            },
                            2: {
                                name: "Video Overlay Banner 300x250( right )",
                                src: "ad2.png"
                            },
                            3: {
                                name: "Native Thumbnail Ad",
                                src: "ad3.png"
                            },
                            4: {
                                name: "Sidebar Video / Detail Banner 300 x 250 ",
                                src: "ad4.png"
                            },
                            5: {
                                name: "VAST Video Ad",
                                src: "ad5.png"
                            },
                            6: {
                                name: "Footer Banner 300x250",
                                src: "ad6.png"
                            },
                            7: {
                                name: "Mobile banner",
                                src: "ad7.png"
                            },
                        }
                    },
                    id: {
                        label: "ID",
                        field: "text"
                    },
                    name: {
                        label: "Name",
                        field: "boldText"
                    },
                    status: {
                        label: "Status",
                        field: "text",
                        conditionalClass: {
                            content: "Inactive",
                            className: "videos-list-status-offline"
                        }
                    },
                    views: {
                        label: "Views",
                        field: "number"
                    },
                    device: {
                        label: "Devices",
                        field: "list",
                        noSort: true,
                        icons: {
                            "1": (<DesktopMacOutlined/>),
                            "2": (<SmartphoneOutlined/>),
                        }
                    },
                    categories: {
                        label: "Categories",
                        field: "list",
                        noSort: true
                    },
                    scheduled_from: {
                        label: "Scheduled from",
                        field: "text"
                    },
                    scheduled_to: {
                        label: "Scheduled to",
                        field: "text"
                    }
                }}
            />
        </div>
    );
}

export default AdvertisementsList;